export default "__VITE_ASSET__DP6ONt0r__"